enum AccountType {
  User = 'User',
  Admin = 'Admin',
  Distributor = 'Distributor',
  Any = 'Any',
}
export default AccountType;
